// The sitter page is read on a phone, often in a hurry: a phone number in
// the owner's "if something is wrong" note should be one tap to call.
// Splits free text into plain parts and phone numbers ({ text, tel }).
// A run needs 7+ digits so a time ("8:30") or an amount ("2 cubes") stays
// text, and a written date (2026-10-04, 04.10.2026, 4/10/26, 2026.10.04) is
// left alone: "Back 04.10.2026" became a link that dialled 04102026.
const PHONE = /\+?\d[\d\s().-]{5,}\d/g;
// Three groups and no more, so a phone written 06.12.34.56.78 is not a date.
// The leading group stands in for a lookbehind, which iOS before 16.4 cannot
// parse (the whole page would fail to load there).
const DATE =
  /(^|[^\d./-])(\d{1,2}[./-]\d{1,2}[./-](?:\d{4}|\d{2})|\d{4}[./-]\d{1,2}[./-]\d{1,2})(?![\d./-])/g;

export function contactParts(text) {
  const src = String(text || '');
  const out = [];
  // Dates are blanked (same length, so indexes hold) before phones are found,
  // so "04.10.2026 555 201 3344" still finds the number after the date.
  const masked = src.replace(DATE, (_, pre, d) => pre + '_'.repeat(d.length));
  let last = 0;
  for (const m of masked.matchAll(PHONE)) {
    const digits = m[0].replace(/\D/g, '');
    if (digits.length < 7 || digits.length > 15) continue;
    if (m.index > last) out.push({ text: src.slice(last, m.index) });
    out.push({ text: m[0], tel: `${m[0].trim().startsWith('+') ? '+' : ''}${digits}` });
    last = m.index + m[0].length;
  }
  if (last < src.length) out.push({ text: src.slice(last) });
  return out;
}

// A date and time without seconds, in the reader's own locale.
export function careWhen(value) {
  if (!value) return 'Date not recorded';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return 'Date not recorded';
  return d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}

// A calendar day ("2026-10-19") as a date in the reader's locale. Read at
// local noon so no zone can move it to the day before.
export function careDay(value) {
  if (!value) return 'Date not recorded';
  const s = String(value);
  const d = /^\d{4}-\d{2}-\d{2}$/.test(s) ? new Date(`${s}T12:00:00`) : new Date(s);
  if (Number.isNaN(d.getTime())) return 'Date not recorded';
  return d.toLocaleDateString(undefined, { dateStyle: 'medium' });
}
